module.exports = __webpack_public_path__ + "static/customize-phone-1-145612628c43edbabbcb7dbdc3b61bfe.png";